import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'TOPIC_FORM'
export const TopicFormAction = createFormAction(FORM_KEY)